/**
 * Trigger a client-side download of `data` as a pretty-printed JSON file.
 * No-op outside the browser (SSR / tests).
 */
export function downloadJson(filename: string, data: unknown): void {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
